import { parseDateStr } from "./utils";

function startOfDay(date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

function isWeekend(date) {
  const day = date.getDay();
  return day === 0 || day === 6;
}

export function calculateKpiMeasure({ etaDate, completedDate }) {
  const eta = parseDateStr(etaDate);
  const completed = parseDateStr(completedDate);

  if (!eta || !completed) return null;

  const start = startOfDay(eta);
  const end = startOfDay(completed);
  if (end.getTime() === start.getTime()) return "0";

  let businessDayDiff = 0;
  const direction = end > start ? 1 : -1;
  const cursor = new Date(start);
  cursor.setDate(cursor.getDate() + direction);

  while (
    (direction > 0 && cursor <= end) ||
    (direction < 0 && cursor >= end)
  ) {
    if (!isWeekend(cursor)) {
      businessDayDiff += direction;
    }
    cursor.setDate(cursor.getDate() + direction);
  }

  return String(businessDayDiff);
}
